import "../../main";
import $ from 'jquery';
import _ from 'underscore';
import { AddsCustomToolTip } from "../map/customtooltip";
import { ZoomLevel } from '../map/marker';
import { ILocation } from './providerlocator';
import { Ajax, Url } from 'rustig';
import { MarkerClusterer } from '@googlemaps/markerclusterer';

export class Providers {

  map: google.maps.Map;
  providers: Array<google.maps.marker.AdvancedMarkerElement>;
  clusterer: MarkerClusterer;
  previousState: ILocation;
  previousZip: ILocation;
  $infoPanel: JQuery;

  public constructor(map: google.maps.Map, data: Array<IProvider>) {
    this.map = map;
    this.providers = this.buildsProviders(data);
    this.clusterer = new MarkerClusterer({
      map: this.map,
      markers: this.providers,
      algorithmOptions: {
        maxZoom: ZoomLevel.State,
      },
    });
    this.$infoPanel = this.buildsInfoPanel();

    $(document).on('refresh-providers', (event: Event, data?: IProviderData) => {
      this.refresh(data.Facilities);
      this.panTo(data.StateSearchCenter, data.DistanceSearchCenter, data.Distance);
      this.$infoPanel.html(null);
    });

    let $providers = $('[data-providers]');
    if ($providers.length)
      $(document).trigger('refresh-providers', <IProviderData>JSON.parse($providers.val() as string));
  }

  public refresh(data: Array<IProvider>): void {
    this.providers = this.buildsProviders(data);
    this.clusterer.clearMarkers();
    this.clusterer.addMarkers(this.providers);
  }

  public clearsSelection(): void {
    let selected = _.find(this.providers, x => x.isSelected);
    if (selected) {
      var pin = new Image();
      pin.src = selected.icon;
      pin.style['opacity'] = selected.opacity;

      selected.content = pin;
      selected.isSelected = false;
    }
  }

  public getsMarkers(): Array<google.maps.marker.AdvancedMarkerElement> {
    return this.providers;
  }

  buildsProviders(data: Array<IProvider>): Array<google.maps.marker.AdvancedMarkerElement> {
    let self = this;

    return data.map(function (x) {
      let marker = self.buildsProvider(x);

      google.maps.event.addListener(marker, 'click', function () {
        self.clearsSelection();

        var pin = new Image();
        pin.src = marker.icon.replace('.', '-selected.');
        pin.style['opacity'] = marker.opacity;

        marker.content = pin;
        marker.isSelected = true;

        Ajax.execute({ url: new Url(x.Url).setQueryParameter('isMap', 'true').toUrl() });
      });

      return marker;
    });
  }

  buildsProvider(data: IProvider): google.maps.marker.AdvancedMarkerElement {
    let marker = new google.maps.marker.AdvancedMarkerElement({
      position: new google.maps.LatLng(data.Latitude, data.Longitude),
      map: this.map,
      zIndex: data.ZIndex,
    });

    marker.icon = '/content/v3/images/maps/pins/' + data.Icon + '.png';
    marker.opacity = data.Opacity.toString();
    marker.name = data.Name;

    var pin = new Image();
    pin.src = marker.icon;
    pin.style['opacity'] = marker.opacity;
    marker.content = pin;

    let tooltip = `<div class="tooltip-content">
                      <span>${data.Name}</span>
                      ${new BuildsStarRating().execute(data.StarRating)}
                    </div>`
    new AddsCustomToolTip().execute(marker, tooltip);

    return marker;
  }

  buildsInfoPanel(): JQuery {
    let $element = $('<div class="map-info-panel" data-map-info-panel="on"></div>');
    $element.on('click.networkaccess', this.clearsSelection.bind(this));
    this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push($element[0]);
    return $element;
  }

  panTo(stateSearchCenter: ILocation, distanceSearchCenter: ILocation, distance: number): void {
    let locationChanged = function (oldLocation: ILocation, newLocation: ILocation) {
      return newLocation && newLocation.Latitude && newLocation.Longitude && (!oldLocation || (newLocation.Latitude != oldLocation.Latitude || newLocation.Longitude != oldLocation.Longitude));
    }

    if (locationChanged(this.previousState, stateSearchCenter)) {
      this.map.panTo(new google.maps.LatLng(stateSearchCenter.Latitude, stateSearchCenter.Longitude));
      this.map.setZoom(ZoomLevel.State);
    }
    else if (locationChanged(this.previousZip, distanceSearchCenter)) {
      if (distance <= 10)
        this.map.setZoom(ZoomLevel.City);
      else if (distance <= 50)
        this.map.setZoom(ZoomLevel.County);
      else
        this.map.setZoom(ZoomLevel.State);

      this.map.panTo(new google.maps.LatLng(distanceSearchCenter.Latitude, distanceSearchCenter.Longitude));
    }
    this.previousState = stateSearchCenter;
    this.previousZip = distanceSearchCenter;
  }
}

class BuildsStarRating {
  public execute(starRating: number): string {
    if (!starRating) return '';

    let stars = '<div class="stars">';
    for (let i = 0; i < 5; i++) {
      stars += starRating > i ? '<i class="icon-star stars-filled"></i>' : '<i class="icon-star"></i>';
    }
    stars += '</div>';

    return stars;
  }
}

export interface IProvider {
  Name: string;
  StarRating: number;
  Latitude: number;
  Longitude: number;
  Url: string;
  Icon: string;
  Type: string;
  Address: string;
  PhoneNumber: string;
  Opacity: number;
  ZIndex: number;
}

export interface IProviderData {
  Facilities: Array<IProvider>;
  DistanceSearchCenter: ILocation;
  StateSearchCenter: ILocation;
  Distance: number;
}
